const escapeRegex = (value = "") => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const countTitleMatches = (titles, term) =>
  titles.filter((title) =>
    new RegExp(escapeRegex(term), "i").test(title)
  ).length;

/** Only vetted job-role terms — no auto-extract from titles. */
const CURATED_TERMS = [
  { label: "CA Jobs", keyword: "CA" },
  { label: "CS Jobs", keyword: "CS" },
  { label: "CMA Jobs", keyword: "CMA" },
  { label: "Chartered Accountant", keyword: "Chartered Accountant" },
  { label: "Company Secretary", keyword: "Company Secretary" },
  { label: "Cost Accountant", keyword: "Cost Accountant" },
  { label: "Audit", keyword: "Audit" },
  { label: "Internal Audit", keyword: "Internal Audit" },
  { label: "Tax Consultant", keyword: "Tax" },
  { label: "GST", keyword: "GST" },
  { label: "Accounts", keyword: "Accounts" },
  { label: "Finance", keyword: "Finance" },
  { label: "Compliance", keyword: "Compliance" },
  { label: "FP&A", keyword: "FP&A" },
  { label: "Direct Tax", keyword: "Direct Tax" },
  { label: "Indirect Tax", keyword: "Indirect Tax" },
];

/**
 * Build popular search chips from real jobs using a curated allowlist only.
 * Every shown chip is verified against live job titles before display.
 */
export const buildPopularSearchesFromJobs = (jobs = [], limit = 6) => {
  const titles = jobs.map((job) => job?.title || "").filter(Boolean);
  if (!titles.length) return [];

  return CURATED_TERMS.map(({ label, keyword }) => ({
    label,
    keyword,
    count: countTitleMatches(titles, keyword),
  }))
    .filter((item) => item.count > 0)
    .sort((a, b) => b.count - a.count)
    .slice(0, limit)
    .map(({ label, keyword }) => ({ label, keyword }));
};
